<template>
  <my-dialog class="coupon-rule" width="600px" :show="show" title="优惠券说明" @close="onClose">
      <h3>获取优惠券方式：</h3>
      <p>通过活动发放、系统发放、手动领取等方式获得;</p>
      <h3>优惠券如何使用规则：</h3>
      <p>1.每张优惠券仅能使用一次，不找零，不退换，不兑换现金</p>
      <p>2.单笔订/工单只能使用1张优惠券, 不支持同时使用多张, 用券后差额不找零, 不退回；</p>
      <p>3.请在有效期内使用优惠券, 未使用的优惠券过期后, 将自动作废；</p>
      <p>4.用户同一帐号和手机号均视为同一用户；</p>
      <p>5.使用抵用券抵扣部分的费用不开具发票；</p>
      <h3>优惠券失效</h3>
      <p>1.用户优惠券未使用超过有效期将失效；</p>
      <p>2.使用优惠券的订单/工单, 若产生取消订单/工单, 优惠券均不退回；</p>
      <p>3.如需了解更多, 请联系在线客服或拨打客服电话021-60956592；</p>
      <p>4.最终解释权归工业速派所有</p>
  </my-dialog>
</template>
<script>
import myDialog from './gkDialog.vue'
export default {
  components:{
    myDialog
  },
  props:{
    show:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      
    }
  },
  methods: {
    onClose(){
      this.$emit('close',this.show);
    },
  },
}
</script>
<style lang="scss">
.coupon-rule{
  h3{
    font-weight: bold;
    font-size: 14px;
    color: #333;
    line-height: 2;
  }
  p{
    font-size: 14px;
    color: #666;
    line-height: 24px;
    text-indent: 2em;
  }
}
</style>